<template>
  <div class="wrapper">
    <CCHeader></CCHeader>
    <div class="data-wrapper">
      <CCSideBar></CCSideBar>
      <div class="main">
        <div class="report"></div>
      </div>
    </div>
  </div>
</template>

<script>

  import CCHeader from '@/components/common/CCHeader';
  import CCSideBar from '@/components/common/CCSideBar';

  export default {
    name: "management",
    components: {
      CCHeader,
      CCSideBar
    },
  }
</script>

<style lang="scss" scoped>
  .wrapper {
    display: grid;
    grid-template-areas:
            "header"
            "sidebar"
            "content"
            "footer";
    width: 100%;
    overflow-x: hidden;
  }

  .data-wrapper {
    display: flex;
  }

  .main {
    display: grid;
    grid-template-columns: auto;
    //height: calc(100vh - 60px);
    width: 100vw;
  }

  .report {
    padding-top: 20px;
    padding-left: 20px;
    padding-right: 20px;
    background-color: #f0f0f0;
    max-width: 100%;
    height: 100vh;
    width: calc(100vw - 48px);
    position: relative;

    &.sidebar-active {
      padding-left: 125px;
    }
  }

  .clear {
    clear: both;
  }

  @include mobile-only {
    .wrapper {
      display: grid;
      grid-template-areas:
              "header"
              "content"
              "footer";
    }
    grid-template-columns: 100vw;

    .main {
      grid-template-columns: 1fr;
    }

    .report {
      padding: 0;
      background-color: #fff;
      width: 100vw;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/Management.vue